import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

function isEmptyInputValue(value: any): boolean {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

export class CustomValidators {
    static notEmptySpace(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }

            if (control.value.replace(/ +(?= )/g, "") == " ") {
                return { notEmptySpace: true };
            }

            return null;
        };
    }

    /**
     * 'A phone number can only contain 0-9 + ( ) and minimum 7 characters'
     */
    static phoneNumber(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }

            if (control.value.match(/^[(]?(\+[\d]{1,3}\s?)?[\d ()]{7,}$/g)) {
                return null;
            }

            return { phoneNumber: true };
        };
    }

    static blockBooking(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (isEmptyInputValue(control.value)) {
                return undefined;
            }

            if (control.value && control.value.data) {
                return undefined;
            }

            return { blockBooking: true };
        };
    }
}
